export default {
    cn: {
        table: {
            hr: {
                indent: '订单',
                user: '登录账号',
                account: '账号',
                warehouseTime: '开仓时间',
                type: '类型',
                number: '手数',
                variety: '交易品种',
                warehousePrice: '开仓价格',
                stopLoss: '止损',
                stopProfit: '止盈',
                price: '价格',
                serviceCharge: '手续费',
                storageFee: '库存费',
                profit: '获利',
                summarize: '总结',
                applySerialNumber: '申请编号',
                orderNumber: '订单编号',
                withdrawal: '取款金额',
                submitTime: '提交时间',
                state: '状态',
                message: '信息',
                userName: '姓名',
                income: '收入',
                disburse: '支出',
                MoneyInto: '资金转入',
                volumeBusiness: '交易量',
                brokerage: '佣金',
                accrual: '利息',
                profitAndLoss: '盈亏',
                balance: '余额',
                userLiseBrokerage: '代理佣金',
                dealTime: '交易时间',
                annotation: '注释',
                closeOutTime: '平仓时间',
                closeOutPrice: '平仓价格',
                SuperioruserLiseAccount: '上级代理账号',
                netValue: '净值',
                UsedPrepayment: '已用预支付',
                usablePrepayment: '可用预支付',
                prepaymentRatio: '预支付比例',
                subordinateuserLiseNumber: '下级代理总数',
                domesticConsumerNumber: '普通客户总数',
                prepaid: '已用预付款',
                AvailableAdvance: '可用预付款',
                AdvancePaymentRatio: '预付款比例',
                phone: '电话',
                email: '电子邮箱',
                certificate: '证件号码',
                userType: '客户类型',
                swift: 'SWIFT编码',
                bankAccout: '银行账户',
                bankName: '银行名称',
                bankSite: '开户银行地址',
                openOrder: '未平仓订单',
                openOrderlots: '未平仓订单手数',
                openOrderProfitAndLoss: '未平仓订单盈亏',
                usableFund: '可用资金',
                cashDepositProportion: '保证金比例',
                deadline: '以上数据截止',
            }
        }
    },
    hk: {
        table: {
            hr: {
                indent: '訂單',
                user: '登錄帳號',
                account: '帳號',
                warehouseTime: '開倉時間',
                type: '類型',
                number: '手數',
                variety: '交易品種',
                warehousePrice: '開倉價格',
                stopLoss: '止損',
                stopProfit: '止盈',
                price: '價格',
                serviceCharge: '手續費',
                storageFee: '庫存費',
                profit: '獲利',
                summarize: '總結',
                applySerialNumber: '申請編號',
                orderNumber: '訂單編號',
                withdrawal: '取款金額',
                submitTime: '提交時間',
                state: '狀態',
                message: '信息',
                userName: '姓名',
                income: '收入',
                disburse: '支出',
                MoneyInto: '資金轉入',
                volumeBusiness: '交易量',
                brokerage: '佣金',
                accrual: '利息',
                profitAndLoss: '盈虧',
                balance: '餘額',
                userLiseBrokerage: '代理佣金',
                dealTime: '交易時間',
                annotation: '注釋',
                closeOutTime: '平倉時間',
                closeOutPrice: '平倉價格',
                SuperioruserLiseAccount: '上級代理帳號',
                netValue: '淨值',
                UsedPrepayment: '已用預支付',
                usablePrepayment: '可用預支付',
                prepaymentRatio: '預支付比例',
                subordinateuserLiseNumber: '下級代理總數',
                domesticConsumerNumber: '普通客戶總數',
                prepaid: '已用預付款',
                AvailableAdvance: '可用預付款',
                AdvancePaymentRatio: '預付款比例',
                phone: '電話',
                email: '電子郵箱',
                certificate: '證件號碼',
                userType: '客戶類型',
                swift: 'SWIFT編碼',
                bankAccout: '銀行帳戶',
                bankName: '銀行名稱',
                bankSite: '開戶銀行地址',
                openOrder: '未平倉訂單',
                openOrderlots: '未平倉訂單手數',
                openOrderProfitAndLoss: '未平倉訂單盈虧',
                usableFund: '可用資金',
                cashDepositProportion: '保證金比例',
                deadline: '以上資料截止',
            }
        }
    },
    en: {
        table: {
            hr: {
                indent: 'indent',
                user: 'user',
                account: 'account',
                warehouseTime: 'warehouseTime',
                type: 'type',
                number: 'number',
                variety: 'variety',
                warehousePrice: 'warehousePrice',
                stopLoss: 'stopLoss',
                stopProfit: 'stopProfit',
                price: 'price',
                serviceCharge: 'serviceCharge',
                storageFee: 'storageFee',
                profit: 'profit',
                summarize: 'summarize',
                applySerialNumber: 'applySerialNumber',
                orderNumber: 'orderNumber',
                withdrawal: 'withdrawal',
                submitTime: 'submitTime',
                state: 'state',
                message: 'message',
                userName: 'userName',
                income: 'income',
                disburse: 'disburse',
                MoneyInto: 'MoneyInto',
                volumeBusiness: 'volumeBusiness',
                brokerage: 'brokerage',
                accrual: 'accrual',
                profitAndLoss: 'profitAndLoss',
                balance: 'balance',
                userLiseBrokerage: 'userLiseBrokerage',
                dealTime: 'dealTime',
                annotation: 'annotation',
                closeOutTime: 'closeOutTime',
                closeOutPrice: 'closeOutPrice',
                SuperioruserLiseAccount: 'SuperioruserLiseAccount',
                netValue: 'netValue',
                UsedPrepayment: 'UsedPrepayment',
                usablePrepayment: 'usablePrepayment',
                prepaymentRatio: 'prepaymentRatio',
                subordinateuserLiseNumber: 'subordinateuserLiseNumber',
                domesticConsumerNumber: 'domesticConsumerNumber',
                prepaid: 'prepaid',
                AvailableAdvance: 'AvailableAdvance',
                AdvancePaymentRatio: 'AdvancePaymentRatio',
                phone: 'phone',
                email: 'email',
                certificate: 'certificate',
                userType: 'userType',
                swift: 'swift',
                bankAccout: 'bankAccout',
                bankName: 'bankName',
                bankSite: 'bankSite',
                openOrder: 'openOrder',
                openOrderlots: 'openOrderlots',
                openOrderProfitAndLoss: 'openOrderProfitAndLoss',
                usableFund: 'usableFund',
                cashDepositProportion: 'cashDepositProportion',
                deadline: 'deadline',
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/MultiLanguage/table.js